import React from "react"
import PropTypes from "prop-types"
import Dropdown from "../../../../Dropdown/Dropdown"
import { findOption } from "../../../../Opportunity/criteriaOptions"

/** Single choice filter: the first option is the "All/Any" choice. */
const SelectField = ({ id, label, options, value, onChange }) => (
  <Dropdown
    id={id}
    label={label}
    options={options}
    value={findOption(options, value) || options[0]}
    onChange={(option) => onChange(option.id)}
  />
)

SelectField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, value: PropTypes.string }),
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default SelectField
